function popUp() {
  const getButtons = document.querySelectorAll("[data-targetmodal]");
  const video = document.querySelector(".video-block__video");
  const propertyPageVideo = document.querySelector(".property-page__sl-video");
  getButtons.forEach((element) => {
    element.addEventListener("click", showModal, false);
  });
  function showModal() {
    var curScroll = window.pageYOffset;
    this.parentNode.style.transform = "unset";
    let curTarget = this.dataset.targetmodal;
    let getModal = document.querySelector('[data-modalid="' + curTarget + '"]');
    let closeBut = getModal.querySelector(".modal__close");
    if (this.hasAttribute("data-modalhiddenfield")) {
      let hFiled = this.dataset.modalhiddenfield;
      let getHFiled = getModal.querySelector("#setlink-prop");
      getHFiled.value = hFiled;
    }
    getModal.classList.add("active");
    getModal.classList.remove("in-active");

    if (getModal.querySelectorAll("video").length != "") {
      if (video) {
        video.pause();
      }
      if (propertyPageVideo) {
        propertyPageVideo.pause();
      }
      getModal.querySelectorAll("video")[0].play();
    }

    function setFixedClose() {
      if (window.innerWidth > 1023) {
        getModal.scrollTop = 0;
        let getCloseBut = getModal.querySelector(".modal__close");
        let getRightClose = getCloseBut.getBoundingClientRect().left;
        let getTopClose = getCloseBut.getBoundingClientRect().top;
        getCloseBut.style.position = "fixed";
        getCloseBut.style.top = getTopClose + "px";
        getCloseBut.style.left = getRightClose + "px";
        getCloseBut.style.zIndex = "100";
      }
    }

    function setUnFixedClose() {
      if (window.innerWidth > 1023) {
        let getCloseBut = getModal.querySelector(".modal__close");
        getCloseBut.removeAttribute("style");
      }
    }
    setTimeout(setUnFixedClose, 900);
    setTimeout(setFixedClose, 1000);

    getModal.addEventListener("click", hideModal, false);
    closeBut.addEventListener("click", hideClose, false);
    document.body.classList.add("ow-hidden");

    function hideModal(e) {
      if (e.target == this) {
        this.classList.remove("active");
        this.classList.add("in-active");
        document.body.classList.remove("ow-hidden");
        window.scrollTo(0, curScroll);
        if (video) {
          video.play();
        }
        if (propertyPageVideo) {
          propertyPageVideo.play();
        }
        if (this.querySelectorAll("video").length != "") {
          this.querySelectorAll("video")[0].pause();
          this.querySelectorAll("video")[0].currentTime = 0;
        }
        getModal.removeEventListener("click", hideModal, false);
        window.removeEventListener("resize", setUnFixedClose, false);
        window.removeEventListener("resize", setFixedClose, false);
      }
    }

    function hideClose() {
      getModal.classList.remove("active");
      getModal.classList.add("in-active");
      document.body.classList.remove("ow-hidden");
      window.scrollTo(0, curScroll);

      if (getModal.querySelectorAll("video").length != "") {
        getModal.querySelectorAll("video")[0].pause();
        getModal.querySelectorAll("video")[0].currentTime = 0;
      }

      setUnFixedClose();
      closeBut.removeEventListener("click", hideClose, false);
      window.removeEventListener("resize", setUnFixedClose, false);
      window.removeEventListener("resize", setFixedClose, false);
    }

    window.addEventListener("resize", setUnFixedClose, false);
    window.addEventListener("resize", setFixedClose, false);
  }
}
module.exports = popUp;
